// Global
import React from 'react';
import styles from './SkipNav.module.scss';
import useDictionary from 'lib/hooks/useDictionary';
import { smoothScrollToElement } from 'lib/hooks/useScrollElementIntoView';
import { focusUnfocusableElement } from 'lib/utils/dom-utils/tab';
import clsx from 'clsx';

export enum SkipNavVariant {
  Primary = 'Primary',
  Secondary = 'Secondary',
}

export interface SkipNavProps {
  variant: SkipNavVariant;
}

export const SkipNav: React.FC<SkipNavProps> = ({ variant = SkipNavVariant.Primary }) => {
  const { getDictionaryValue } = useDictionary();

  return (
    <a
      href="#main-layout-content"
      className={clsx(styles.skipnav, styles[`skipnav--${variant}`])}
      tabIndex={0}
      onClick={(e) => {
        e.preventDefault();
        const elem = document.getElementById('main-layout-content');
        if (elem) {
          smoothScrollToElement(elem, 'header');
          focusUnfocusableElement(elem, true);
        }
      }}
      data-component="authorable/shared/site-structure/skipnav/skipnav"
    >
      <span>
        {getDictionaryValue('Navigation.SkipNav.SkipToMainContent', 'Skip to main content')}
      </span>
    </a>
  );
};
